import React, { FC } from 'react';

import { ModalInfo } from '@.modal';
import { ChamberData } from '@/Types';

import { ChamberCard } from '../ChamberCard';
import S from './ChambersModal.module.scss';

interface ChambersModalProps {
    deviceId: number;
    chambers: ChamberData[];
}

export const ChambersModal: FC<ChambersModalProps> = ({ chambers }) => {
    return (
        <ModalInfo>
            <div className={S.Root}>
                <h1 className={S.RootTitle}>Chambers</h1>

                <div className={S.Chambers}>
                    {chambers.map((chamber) => (
                        <ChamberCard chamber={chamber} key={chamber.id} />
                    ))}
                </div>
            </div>
        </ModalInfo>
    );
};
